import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import AnimationThemeProvider from './shims/animationThemeProvider';
import CustomizerProvider from './shims/customizerProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  CURRENT_APP,
  USER_DETAILS,
  USER_ROLES,
  USER_SUBSCRIPTION,
} from './constants/commonUiActions';
import Routers from './Router/Routers';

const DEFAULT_MODULE_ROLES = {
  11: [
    'ORG_ADMIN',
    'PLATFORM_ADMIN',
    'ASO_ADMIN',
    'ASO_USER',
    'EMISSIONS_ADMIN',
    'EMISSIONS_APPROVER',
    'EMISSIONS_ANALYST',
  ],
};

function cookieBase() {
  return {
    path: '/',
    sameSite: 'Lax',
    expires: 7,
    ...(typeof process !== 'undefined' &&
    process.env &&
    process.env.REACT_APP_COOKIE_DOMAIN
      ? { domain: process.env.REACT_APP_COOKIE_DOMAIN }
      : {}),
  };
}

function ensureShellCookies() {
  const base = cookieBase();
  const jwt = Cookies.get('accessToken') || Cookies.get('jwtToken');
  if (jwt) {
    sessionStorage.setItem('accessToken', jwt);
    if (!Cookies.get('accessToken')) Cookies.set('accessToken', jwt, base);
  }
  if (!Cookies.get('CurrentApp')) Cookies.set('CurrentApp', '11', base);
  if (!Cookies.get('userType')) {
    const fallback = 'ASO_USER';
    Cookies.set('userType', fallback, base);
    sessionStorage.setItem('userType', fallback);
  }
  if (!Cookies.get('userRoles')) {
    Cookies.set('userRoles', JSON.stringify(DEFAULT_MODULE_ROLES), base);
  }
}

export default function TicketingRoot() {
  const dispatch = useDispatch();

  useEffect(() => {
    ensureShellCookies();
    dispatch({ type: CURRENT_APP, payload: 11 });
    dispatch({
      type: USER_SUBSCRIPTION,
      payload: Cookies.get('userSubscription') ? JSON.parse(Cookies.get('userSubscription')) : null,
    });
    dispatch({
      type: USER_ROLES,
      payload: Cookies.get('userRoles') ? JSON.parse(Cookies.get('userRoles')) : DEFAULT_MODULE_ROLES,
    });
    dispatch({
      type: USER_DETAILS,
      payload: Cookies.get('userProfile') ? JSON.parse(Cookies.get('userProfile')) : null,
    });
  }, [dispatch]);

  return (
    <AnimationThemeProvider>
      <CustomizerProvider>
        <Routers />
        <ToastContainer />
      </CustomizerProvider>
    </AnimationThemeProvider>
  );
}
